import { Badge, LuIcon } from "@overmap-ai/blocks"
import { ProcedureStepFieldValuesReviewType } from "@overmap-ai/common"
import { type ComponentPropsWithRef, memo } from "react"

import { procedureStepFieldValuesReviewTypeData } from "../../mappings/procedures"

interface ProcedureStepReviewTypeBadgeProps extends Omit<ComponentPropsWithRef<typeof Badge>, "children"> {
	type: ProcedureStepFieldValuesReviewType
}

export const ProcedureStepReviewTypeBadge = memo<ProcedureStepReviewTypeBadgeProps>((props) => {
	const { icon, type, accentColor = "base", variant = "soft", ...rest } = props

	const { icon: typeIcon, statusLabel, color } = procedureStepFieldValuesReviewTypeData[type]

	return (
		<Badge icon={icon} accentColor={accentColor} variant={variant} {...rest}>
			<LuIcon icon={typeIcon} color={color} />
			{!icon ? statusLabel : null}
		</Badge>
	)
})
ProcedureStepReviewTypeBadge.displayName = "ProcedureStepReviewTypeBadge"
